import { OneClick } from '@/components/blocks/OneClick';
import { Box } from '@mui/material';
import { MouseEvent } from 'react';
import { actionItemSX, actionsSX } from '@/components/blocks/EmailRecommendedCouponPopup/styles';

interface PopupActionsProps {
	onAddToCart: (event: MouseEvent<HTMLButtonElement>) => void;
	onGoToCheckout: (event: MouseEvent<HTMLButtonElement>) => void;
	disabled?: boolean;
}

export const PopupActions = ({ onAddToCart, disabled = false }: PopupActionsProps) => (
	<Box sx={actionsSX}>
		{/*<Box sx={actionItemSX}>
			<DpButton
				variant="unfocused"
				fullWidth
				sx={actionButtonSX}
				onClick={onAddToCart}
				disabled={disabled}
			>
				{ADD_BUTTON_LABEL}
			</DpButton>
		</Box> */}
		<Box sx={actionItemSX}>
			<OneClick wrapper="dp-button" fullWidth onClick={onAddToCart} disabled={disabled}>
				{'Agregar al carrito'}
			</OneClick>
		</Box>
	</Box>
);
